<template>
  <div id="dining">
    <div class="container">
      <h1>Dining</h1>
      <hr>

      <!-- Create Location -->
      <button
        v-if="view === 'locations'"
        class="nav-link btn btn-outline-light mr-2"
        @click="createLocation()"
      ><i class="fas fa-plus"></i> Create Location</button>

      <!-- List of Locations -->
      <div
        v-if="view === 'locations' && dashboard.data.modules.dining.locations.length > 0"
        class="row mt-2"
      >
        <div
          v-for="(location, index) in dashboard.data.modules.dining.locations"
          class="col-sm-4"
        >
          <div class="card">
            <img class="card-img-top" :src="location.imageUrl">
            <div class="card-body">
              <h5>{{ location.title }}</h5>
              <p
                v-if="location.active"
                class="text-success"
              ><small><strong>Active</strong></small></p>
              <p
                v-if="!location.active"
                class="text-danger"
              ><small><strong>Closed</strong></small></p>

              <button
                @click="editLocation(index)"
                class="btn btn-outline-dark"
              >
                <i class="fas fa-edit"></i>
              </button>
              <button
                @click="deleteLocation(index)"
                class="btn btn-outline-danger"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </div><!-- /.card-body -->
          </div><!-- /.card -->
        </div><!-- /.col-sm-4 -->
      </div><!-- /.row -->

      <!-- Location Details -->
      <button
        v-if="view === 'editLocation'"
        class="nav-link btn btn-outline-light mr-2"
        @click="view = 'locations'"
      ><i class="fas fa-arrow-left"></i> All Locations</button>
      <form
        class="mt-2"
        v-if="view === 'editLocation'"
        @submit.prevent
      >
        <!-- Location Name -->
        <div class="form-group">
          <label>Location Name</label>
          <input class="form-control" v-model="dashboard.data.modules.dining.locations[currentLocation].title" />
        </div><!-- /.form-group -->
        <!-- Location Image URL -->
        <div class="form-group">
          <label>Location Image URL</label>
          <input class="form-control" v-model="dashboard.data.modules.dining.locations[currentLocation].imageUrl" />
        </div><!-- /.form-group -->

        <!-- Checkbox for activating the location -->
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="dashboard.data.modules.dining.locations[currentLocation].active"
            id="dining">
          <label class="form-check-label" for="dining">
            Location Active
          </label>
        </div><!-- /.form-check -->


        <ul class="nav nav-pills mb-2">
          <li class="nav-item">
            <button
              class="nav-link btn btn-outline-light mr-2"
              :class="{ active: currentDay === 0 }"
              @click="currentDay = 0"
            >Sun</button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link btn btn-outline-light mr-2"
              :class="{ active: currentDay === 1 }"
              @click="currentDay = 1"
            >Mon</button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link btn btn-outline-light mr-2"
              :class="{ active: currentDay === 2 }"
              @click="currentDay = 2"
            >Tue</button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link btn btn-outline-light mr-2"
              :class="{ active: currentDay === 3 }"
              @click="currentDay = 3"
            >Wed</button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link btn btn-outline-light mr-2"
              :class="{ active: currentDay === 4 }"
              @click="currentDay = 4"
            >Thu</button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link btn btn-outline-light mr-2"
              :class="{ active: currentDay === 5 }"
              @click="currentDay = 5"
            >Fri</button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link btn btn-outline-light mr-2"
              :class="{ active: currentDay === 6 }"
              @click="currentDay = 6"
            >Sat</button>
          </li>
        </ul>

        <!-- Create Location -->
        <button
          v-if="view === 'editLocation'"
          class="nav-link btn btn-outline-light m-2"
          @click="createMeal()"
        ><i class="fas fa-plus"></i> Create Meal</button>

        <!-- DISPLAY MENU -->
        <div class="meals">
          <b-card
            v-for="(meal, index) in dashboard.data.modules.dining.locations[currentLocation].days[currentDay].meals"
            v-bind:key="index"
            no-body
            class="mb-1"
          >
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle="'accordion-' + index" variant="outline-light">{{ meal.title }}</b-button>
            </b-card-header>
            <b-collapse :id="'accordion-' + index" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <div class="card-body-header">
                  <button
                    @click="editMeal(index)"
                    class="btn btn-outline-dark"
                  >
                    <i class="fas fa-edit"></i>
                  </button>
                  <button
                    @click="deleteMeal(index)"
                    class="btn btn-outline-danger"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>
                  <p class="meal-icon" v-html="meal.icon"></p>
                </div><!-- /.card-body-header -->

                <!-- Meal Times -->
                <h3><span v-if="meal.startTime">{{ meal.startTime | toTime }}</span><span v-if="meal.endTime"> - {{ meal.endTime | toTime }}</span></h3>

                <!-- Meal Description -->
                <div v-html="meal.description"></div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div><!-- /.meals -->

        <button
          class="btn btn-primary mt-2"
          @click="updateLocation()"
        >Save Location</button>
      </form>

      <!-- EDIT MEAL -->
      <div
        v-if="view == 'editMeal'"
      >

      <form
        class="mt-2"
        @submit.prevent
      >
        <div class="form-group">
          <label>Meal Title</label>
          <input class="form-control" v-model="dashboard.data.modules.dining.locations[currentLocation].days[currentDay].meals[currentMeal].title" />
        </div><!-- /.form-group -->

        <div class="form-group">
          <label>Meal Description</label>
          <quill-editor
            v-model="dashboard.data.modules.dining.locations[currentLocation].days[currentDay].meals[currentMeal].description"
            :options="editorOptions"
          ></quill-editor>
        </div><!-- /.form-group -->

        <div class="form-group">
          <label>Meal Icon (from <a href="https://fontawesome.com" target="_blank">Fontawesome</a>)</label>
          <input class="form-control" v-model="dashboard.data.modules.dining.locations[currentLocation].days[currentDay].meals[currentMeal].icon" />
        </div><!-- /.form-group -->

        <!-- START TIME -->
        <div class="form-group">
          <label for="pac-input">Start Time</label>
          <div class="input-group">
            <date-picker
              v-model="dashboard.data.modules.dining.locations[currentLocation].days[currentDay].meals[currentMeal].startTime"
              :lang="'en'"
              :placeholder="'Select Start Time'"
              format="hh:mm a"
              :time-picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
              type="time"
              appendToBody
            ></date-picker>
          </div>
        </div><!-- /.form-group -->

        <!-- END TIME -->
        <div class="form-group">
          <label for="pac-input">End Time</label>
          <div class="input-group">
            <date-picker
              v-model="dashboard.data.modules.dining.locations[currentLocation].days[currentDay].meals[currentMeal].endTime"
              :lang="'en'"
              :placeholder="'Select End Time'"
              format="hh:mm a"
              :time-picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
              type="time"
              appendToBody
            ></date-picker>
          </div>
        </div><!-- /.form-group -->

        <button
          class="btn btn-primary mt-2"
          @click="updateMeal()"
        >Save Meal</button>
      </form>

      </div>
    </div><!-- /.container -->
  </div><!-- /#dining -->
</template>

<script>
import { mapState } from 'vuex'
import DatePicker from 'vue2-datepicker'
const fb = require('../../../firebaseConfig.js')
import moment from 'moment'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  data() {
    return {
      currentMeal: 0,
      currentDay: 0,
      currentLocation: null,
      view: 'locations',
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'header': [1, 2, 3, false] }],
            [{ 'align': [] }],
            ['clean'],
            ['link', 'video']
          ]
        }
      }
    }
  },
  components: {
    DatePicker,
    quillEditor
  },
  methods: {
    updateMeal() {
      fb.dashboardsCollection.doc(this.dashboard.data.id).update({
        modules: this.dashboard.data.modules
      }).then(e => {
        const revData = this.dashboard.data
        revData.updatedOn = new Date()
        fb.dashboardRevisionsCollection.add(revData)
        alert('Successfully update this meal!')
        this.$store.commit('fetchDashboard', {id: this.$route.params.id, customStyles: false})
        this.view = 'editLocation'
      })
    },
    editMeal(index) {
      this.currentMeal = index
      this.view = 'editMeal'
    },
    deleteMeal(index) {
      let check = confirm("DANGER! Are you sure you want to delete this meal? This cannot be undone!");
      if (check == true) {
        this.dashboard.data.modules.dining.locations[this.currentLocation].days[this.currentDay].meals.splice(index, 1)
        fb.dashboardsCollection.doc(this.dashboard.data.id).update({
          modules: this.dashboard.data.modules
        }).then(e => {
          const revData = this.dashboard.data
          revData.updatedOn = new Date()
          fb.dashboardRevisionsCollection.add(revData)
          this.$store.commit('fetchDashboard', {id: this.$route.params.id, customStyles: false})
        })
      } else {
        return false
      }
    },
    createMeal() {
      let mealObject = {
        title: 'New Meal',
        description:'Fried eggs with biscuits and sausage or mushroom gravy. Millet or greens on the side. Fresh melons or grapes for the fruit.',
        icon: '<i class="fas fa-utensils"></i>',
        startTime: new Date(),
        endTime: new Date()
      }
      this.dashboard.data.modules.dining.locations[this.currentLocation].days[this.currentDay].meals.unshift(mealObject)
      fb.dashboardsCollection.doc(this.dashboard.data.id).update({
        modules: this.dashboard.data.modules
      }).then(e => {
        const revData = this.dashboard.data
        revData.updatedOn = new Date()
        fb.dashboardRevisionsCollection.add(revData)
        this.$store.commit('fetchDashboard', {id: this.$route.params.id, customStyles: false})
      })
    },
    updateLocation() {
      fb.dashboardsCollection.doc(this.dashboard.data.id).update({
        modules: this.dashboard.data.modules
      }).then(e => {
        const revData = this.dashboard.data
        revData.updatedOn = new Date()
        fb.dashboardRevisionsCollection.add(revData)
        alert('Successfully update this location!')
        this.$store.commit('fetchDashboard', {id: this.$route.params.id, customStyles: false})
        this.view = 'locations'
      })
    },
    deleteLocation(index) {
      let check = confirm("DANGER! Are you sure you want to delete this location? This cannot be undone!");
      if (check == true) {
        this.dashboard.data.modules.dining.locations.splice(index, 1)
        fb.dashboardsCollection.doc(this.dashboard.data.id).update({
          modules: this.dashboard.data.modules
        }).then(e => {
          const revData = this.dashboard.data
          revData.updatedOn = new Date()
          fb.dashboardRevisionsCollection.add(revData)
          this.$store.commit('fetchDashboard', {id: this.$route.params.id, customStyles: false})
        })
      } else {
        return false
      }
    },
    editLocation(index) {
      this.currentLocation = index
      this.view = 'editLocation'
    },
    createLocation() {
      let locationObject = {
        title: 'New Location',
        active: true,
        days: {
          0: {
            day: 'Sunday',
            meals: []
          },
          1: {
            day: 'Monday',
            meals: []
          },
          2: {
            day: 'Tuesday',
            meals: []
          },
          3: {
            day: 'Wednesday',
            meals: []
          },
          4: {
            day: 'Thursday',
            meals: []
          },
          5: {
            day: 'Friday',
            meals: []
          },
          6: {
            day: 'Saturday',
            meals: []
          }
        }
      }
      this.dashboard.data.modules.dining.locations.unshift(locationObject)
      fb.dashboardsCollection.doc(this.dashboard.data.id).update({
        modules: this.dashboard.data.modules
      }).then(e => {
        const revData = this.dashboard.data
        revData.updatedOn = new Date()
        fb.dashboardRevisionsCollection.add(revData)
        this.$store.commit('fetchDashboard', {id: this.$route.params.id, customStyles: false})
      })
    }
  },
  computed: {
    ...mapState([
      'admin',
      'dashboard',
      'userProfile',
      'currentUser'
    ])
  },
  filters: {
    toTime(value) {
      let time = new Date(value.seconds * 1000)
      return moment(time).format('h:mm a')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/modules/Dining.vue